import { Routes } from '@angular/router';

import { applicationRoutes } from './app/application.routes';
import { mpsRoutes } from './mps/routes/mps.routes';

export const globalRoutes: Routes = [
  ...applicationRoutes,
  ...mpsRoutes,
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
